// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/dist/bootstrap-vue.css
// module id = 1108
// module chunks = 2